<template>
  <span>{{time ? momentMixin(time, fmt) : ''}}</span>
</template>

<script>
export default {
    props: {
        time: {
            default: ''
        },
        fmt: {
            default: 'LL'
        },
    },
}
</script>